export default {
  getFeedbackType: '/survey/api/getFeedBackClassifys', // 获取问题反馈类型
  createFeedback: '/survey/api/{0}/{1}/0/{2}/{3}/createFeedBack', // 创建问题反馈
  getFeedbackInfo: '/survey/api/getFeedBacks', // 获取问题反馈详情
  getFeedbackTable: '/survey/api/getFeedBacks/{0}/{1}', // 获取问题反馈列表
  deleteFeedback: '/survey/api/deleteFeedBack/{0}', // 删除问题反馈
  submitFeedback: '/survey/api/appraisal' // 提交问题反馈
};
